var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41895 0.0253906H10.4961C10.8739 0.0253906 11.2016 0.163397 11.4795 0.441406C11.7575 0.719272 11.8955 1.04701 11.8955 1.4248V13.2686C11.8954 13.7731 11.6867 14.1618 11.2676 14.4375C10.8482 14.7132 10.4068 14.7514 9.94141 14.5508L5.96777 12.8506L5.95801 12.8457L5.94824 12.8506L1.97461 14.5508C1.50923 14.7514 1.06906 14.7131 0.651367 14.4375C0.233704 14.1618 0.0255089 13.7732 0.0253906 13.2686V1.4248C0.0253906 1.04696 0.163384 0.719272 0.44043 0.441406C0.717188 0.163648 1.04283 0.0254959 1.41895 0.0253906ZM1.39453 13.3057L1.42871 13.291L5.95703 11.3818L10.4863 13.291L10.5215 13.3057V1.39941H1.39453V13.3057Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSaveIcon);
export default __webpack_public_path__ + "static/media/new-save-icon.f1fab8f323e6766dc5ef60965c14a9d4.svg";
export { ForwardRef as ReactComponent };